const HomeIcon = () => (
	<div>
		<svg>
			<path fill="none" d="M0 0h24v24H0V0z" />
			<path d="M12 5.69l5 4.5V18h-2v-6H9v6H7v-7.81l5-4.5M12 3L2 12h3v8h6v-6h2v6h6v-8h3L12 3z" />
		</svg>
		<svg active>
			<path fill="none" d="M0 0h24v24H0V0z" />
			<path d="M12 3L2 12h3v8h6v-6h2v6h6v-8h3L12 3zm5 15h-2v-6H9v6H7v-7.81l5-4.5 5 4.5V18z" />
			<path opacity=".3" d="M7 10.19V18h2v-6h6v6h2v-7.81l-5-4.5z" />
		</svg>
	</div>
);

export default HomeIcon;


// WEBPACK FOOTER //
// ./components/SVG/Icons/home.js